import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="3D Portfolio"
              description="This is my 3D portfolio, I made using ReactJS, Tailwind CSS and ThreeJS. I made this project under a web course and below is a live link for this project."
              ghLink="https://github.com/SahilAgrwaL/Portfolio3D.git"
              demoLink="https://sahilagarwal3dportfolio.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Crypt'nfo"
              description="Crypt'nfo' is a Cryptocurrency App which provides details on the top cryptocurrencies and cryptocurrency news. It uses React best practices, Redux, UI Creation using Ant Design and fetching data from RapidAPI.."
              ghLink=""
              demoLink="https://cryptnfo.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Handover Fitness"
              description="A comprehensive fitness information platform that allows users to know about an exercise, and offers recommendations for suitable exercise and their target muscle group."
              ghLink="https://github.com/SahilAgrwaL/HandoverFitness.git"
              demoLink="https://handoverfitnessclub.netlify.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="The Broad Consultant"
              description="@as intern at AIM Infotech. Website for a Business which I made during my internship at Aim Infotech with my fellow team-mates, under guidance of my mentor during my training."
              // ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="https://thebroadconsultant.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Calculator"
              description="Simple Calculator - My First Project!!."
              ghLink="https://github.com/SahilAgrwaL/Calculator"
              demoLink="https://calculatorbysahilagarwal.netlify.app/" 
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
